import axios from 'axios';

export default {
    state: {
        employees: null,
    },
    getters: {
        getEmployees(state) {
            return state.employees
        },
    },
    mutations: {
        setEmployees(state, data) {
            return state.employees = data
        },
    },
    actions: {
        employeesRequest(context) {
            return axios.get('/api/branches/list/employees')
                .then(res => {
                    context.commit('setEmployees', res.data)
                })
        },
    }
}